import script from "./TreeViewEditorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./TreeViewEditorDialog.vue?vue&type=script&setup=true&lang=ts"

import "./TreeViewEditorDialog.vue?vue&type=style&index=0&id=245a5139&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-245a5139"]])

export default __exports__